import { FeatureTogglePort } from '@otto-ec/eprivacy-shared'

export const USE_CB_ALLOW_APM_CB_LOADTIME = 'cb_allow_apm_cb_loadtime'
export function allowApmCbLoadTine(
  featureTogglePort: FeatureTogglePort
): boolean {
  return featureTogglePort(USE_CB_ALLOW_APM_CB_LOADTIME, false)
}
